import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { SharedModule } from '@feature/_app_modules/shared/shared.module';
import { EmptyLayoutComponent } from '@feature/_app_modules/layout/layouts/empty-layout/empty-layout/empty-layout.component';


@NgModule({
  declarations: [EmptyLayoutComponent],
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports: [
    EmptyLayoutComponent
    ]
})
export class EmptyModule { }
